/* eslint-disable */

import React, { Component,useState, useEffect } from 'react';
import { Input as AntdInput } from 'antd';
import classNames from "classnames";
import './input.less';
import MaskedInput from 'antd-mask-input';

const InputWrapper = ({ children, label, info, className }) => {
  return (
    <>
      <div className={classNames('input',className)}>
        {label ? <label>{label}</label> : null}
        <div>
          {children}
        </div>
        {info ? info : null}
      </div>
    </>
    )
};

const Password =(passwordInputProps)=>{
  const [inputFocused, setInputFocused] = useState(false);

  useEffect(() => {
    if (passwordInputProps.value) {
      setInputFocused(true);
    } else {
      setInputFocused(false)
    }
  }, [passwordInputProps.value]);

  function onChange(e){
    passwordInputProps.onChange(e);
  }

  function focusInput() {
    setInputFocused(true);
  }

  function blurInput(e) {
    if (!e.target.value.length) {
      setInputFocused(false);
    }
  }
  return (
    <InputWrapper className={classNames({'focus':inputFocused}, passwordInputProps.compClass)} label={passwordInputProps.label}>
      <AntdInput.Password bordered={false} {...passwordInputProps} onChange={(e)=>{onChange(e)}} onBlur={blurInput} onFocus={focusInput} />
    </InputWrapper>
  )
};
const Group = (groupProps) =>{
  return AntdInput.Group(groupProps)
};
const Search=(searchInputProps)=> {
  return (
    <InputWrapper>
      <AntdInput.Search bordered={false} {...searchInputProps} className="custom-input" />
    </InputWrapper>
  );
};

const TextArea = (textAreaProps)=>{
  const [textareaValue, setTextareaValue] = useState('')

  function onChange(e){
    setTextareaValue(e.target.value);
    textAreaProps.onChange(e);
  }

  return (
    <div className="input--text-area">
      <AntdInput.TextArea {...textAreaProps} onChange={onChange}  />
      { textAreaProps.showChar ? null : null }

    </div>
  );
};

const MaskInput = (props)=>{
  const [inputFocused, setInputFocused] = useState(false);

  useEffect(() => {
    if (props.value) {
      setInputFocused(true);
    } else {
      setInputFocused(false)
    }
  }, [props.value]);

  function focusInput() {
    setInputFocused(true);
  }

  function blurInput(e) {
    if (!e.target.value.length) {
      setInputFocused(false);
    }
  }

  return (
    <InputWrapper className={classNames({'focus':inputFocused}, props.compClass)} label={props.label}>
      <MaskedInput {...props} mask="11 : 11" placeholder="" name="clock" size="4" onBlur={blurInput} onFocus={focusInput}/>
    </InputWrapper>
  );
};

const Input = (props) => {

  const [inputFocused, setInputFocused] = useState(false);

  useEffect(() => {
    if (props.value) {
      setInputFocused(true);
    } else {
      setInputFocused(false)
    }
  }, [props.value]);


  function onChange(e){
    props.onChange(e);
  }

  function focusInput() {
    setInputFocused(true);
  }

  function blurInput(e) {
    if (!e.target.value.length) {
      setInputFocused(false);
    }
  }

    return (
      <InputWrapper className={classNames({'focus':inputFocused}, props.compClass)} label={props.label} info={props.info}>
        <AntdInput bordered={false} {...props} onChange={(e)=>{onChange(e)}} onBlur={blurInput} onFocus={focusInput} />
      </InputWrapper>
    );
}


Input.Password = Password;
Input.Group = Group;
Input.Search = Search;
Input.TextArea = TextArea;
Input.MaskInput = MaskInput;

export default Input